module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAUElEQVQ4y2NgGBTgPxZwR1wWBWMDg8gABobq/9hwQsLa/8nJ6/7jksdqALIme/s5YIzbMCwGwDTBNMBoZMPwGoBuEHaNaAYMg2ikQjoYygAAec2zGQOunwEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/AN.png
// module id = 1074
// module chunks = 0